<template>
  <b-row>
    <b-col cols="12" lg="3">
      <CrmProfile />
    </b-col>
    <b-col cols="12" lg="9" class="content-section">
      <router-view></router-view>
    </b-col>
  </b-row>
</template>

<script>
import CrmProfile from '../../../components/adminCrm/CrmProfile.vue'
export default {
  components: {
    CrmProfile,
  },
}
</script>

<style scoped>
.content-section {
  height: calc(100vh - 138px);
  overflow-y: auto;
}
::-webkit-scrollbar {
  display: none;
}
</style>
